import React from 'react'
import Popup from 'reactjs-popup'
import Loader from 'react-loader-spinner'
import { AiOutlineClose } from 'react-icons/ai'

const styles = {
  popupContentContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexFlow: 'column',
    alignItems: 'center',
    padding: '8px',
    paddingRight: '16px'
  },
  popupHeaderClose: {
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'space-between',
    width: '100%'
  },
  popupHeader: {
    margin: '0',
    color: '#3E3E3E',
    fontSize: '24px'
  },
  popupParagraph: {
    textAlign: 'center',
    width: '100%',
    fontSize: '20px'
  },
  popupDivisor: {
    width: '100%',
    margin: '8px',
    backgroundColor: '#a2a2a2',
    height: '1px'
  },
  popupAcceptButton: {
    flex: 1,
    color: '#ffffff',
    cursor: 'pointer',
    textAlign: 'center',
    borderRadius: '16px',
    margin: '16px 0px 4px 4px',
    paddingTop: '8px',
    paddingBottom: '4px',
    fontWeight: 'bold',
    backgroundColor: '#935da3'
  },
  popupTwoButton: {
    flex: 1,
    color: '#935da3',
    border: '1.5px solid #935da3',
    cursor: 'pointer',
    textAlign: 'center',
    borderRadius: '16px',
    margin: '6px 0px 4px 4px',
    paddingTop: '8px',
    paddingBottom: '4px',
    fontWeight: 'bold'
  },
  popupNoEvaluationButton: {
    flex: 1,
    color: '#ffffff',
    textAlign: 'center',
    borderRadius: '16px',
    margin: '16px 4px 4px 0px',
    paddingTop: '8px',
    paddingBottom: '4px',
    fontWeight: 'bold',
    backgroundColor: '#ff0000',
    cursor: 'pointer'
  },
  popupContentStyle: {
    maxWidth: '768px',
    width: '100%',
    margin: 'auto',
    backgroundColor: '#E0E0E0'

  },
  popupOverlayStyle: {
    padding: '16px'
  },
  buttonsContainer: {
    display: 'flex',
    flexFlow: 'row',
    width: '100%'
  }
}

class PopupTwoButtons extends React.Component {
  renderPopupContent = () => {
    return (
      <div style={styles.popupContentContainer}>
        <div style={styles.popupHeaderClose}>
          {this.props.textHeader &&
          <p style={styles.popupHeader}>
            {this.props.textHeader}
          </p>}
          {this.props.closeButton &&
          <AiOutlineClose size='30' color='#707070' onClick={() => this.props.close()} />}
        </div>
        {this.props.textHeader &&
        <div style={styles.popupDivisor} />
        }
        <div style={styles.popupParagraph}>
          {this.props.textParagraph}
        </div>
        <div style={styles.buttonsContainer}>
          <div style={styles.popupAcceptButton} id='button-send' ref='buttonSend'
            onClick={this.props.buttonAction}
          >
            {this.props.loading ? (
              <Loader
                type='TailSpin'
                color='var(--gray-lighter)'
                height={20}
                width={20}
              />
            ) : (
              this.props.textButton
            )}
          </div>
        </div>
        {this.props.isTwoButtons && (
          <div style={styles.buttonsContainer}>
            <div style={styles.popupTwoButton} id='button-send' ref='buttonTwo'
              onClick={() => this.props.close()}
            >
              {this.props.textTwoButton}
            </div>
          </div>
        )}
      </div>
    )
  }

  renderPopup = () => {
    return (
      <Popup
        open={this.props.open}
        position='right center'
        contentStyle={styles.popupContentStyle}
        overlayStyle={styles.popupOverlayStyle}
        closeOnDocumentClick
        onClose={this.props.close}
      >
        <div className='modal'>
          {this.renderPopupContent()}
        </div>
      </Popup>
    )
  }

  render () {
    return (
      <React.Fragment>
        {this.props.children}
        {this.renderPopup()}
      </React.Fragment>
    )
  }
}
export default PopupTwoButtons



// WEBPACK FOOTER //
// ./src/services/PopupTwoButtons.js